// These two values combined uniquely identifies a B2C subscription.
export class B2CSubscriptionIdentity {
  issuer: string;
  recipient: string;

  getSSN(): string {
    const end = this.recipient?.indexOf('.');
    return this.recipient?.substring(0, end);
  }

  getBankCode(): string {
    const start = this.recipient?.indexOf('.') + 1;
    const end = this.recipient?.indexOf('.', start);
    return this.recipient?.substring(start, end);
  }

  equals(other: B2CSubscriptionIdentity): boolean {
    return this.recipient === other.recipient && this.issuer === other.issuer;
  }

  toString(culture?: string): string {
    return `${this.issuer} -> ${this.recipient}`;
  }

  public static Map(source: B2CSubscriptionIdentity): B2CSubscriptionIdentity {
    if (!source) {
      throw new Error('B2CSubscriptionIdentity missing');
    }
    return Object.assign(new B2CSubscriptionIdentity(), source);
  }
}
